export default __webpack_public_path__ + "static/media/recurring-requests.0bdf608f.svg";